import FontFaceObserver from 'font-face-observer';

/** Applies relevant classes when a font has been successfully loaded */
class FontLoader {
  /**
   * @param {object} options Font family and class information
   */
  constructor(options) {
    this.fontFace = options.fontFace;
    this.fontClass = options.fontClass;
    this.html = $('html');
    if (!this.fontFace || !this.fontClass) {
      throw new Error('You must define both a fontFace and fontClass');
    }
    if (!this.isPreloaded()) {
      this.createObserver();
    }
  }
  /**
   * Checks location storage to see if font has already been loaded
   * @returns {boolean}
   */
  isPreloaded() {
    if (localStorage.getItem(this.fontClass)) {
      this.html.addClass('fonts-loaded').addClass(this.fontClass);
      return true;
    }
    return false;
  }
  /**
   * Waits until a font has been loaded, then applies classes and localStorage flag
   */
  createObserver() {
    const observer = new FontFaceObserver(this.fontFace, {});
    observer.check().then(() => {
      if (!localStorage.getItem(this.fontClass)) {
        this.html.addClass('fonts-loaded').addClass(this.fontClass);
        localStorage.setItem(this.fontClass, true);
      }
    }, () => {
      this.html.addClass('no-fonts-loaded');
    });
  }
}
export default FontLoader;
